import React, { FC } from 'react';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { getSlugLinkProps, urlEnum } from '@utils/url';
import classnames from 'classnames';

import './NavigationLink.scss';

interface NavigationLinkProps {
  slug: string | undefined;
  className?: string;
}

export const NavigationLink: FC<NavigationLinkProps> = ({ slug, className, children }) => {
  const rootClass = classnames('navigation-link', className);
  const linkProps = slug ? getSlugLinkProps(urlEnum.guides, slug) : undefined;
  return linkProps ? (
    <PlcAnchor className={rootClass} linkProps={linkProps}>
      {children}
    </PlcAnchor>
  ) : (
    <div className={rootClass}>{children}</div>
  );
};
